/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-07-11 15:42:00
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-24 11:13:07
 */

import { type ProColumns, ProTable, ProFormText } from "@ant-design/pro-components";
import {
	fetchADAccountList,
	fetchAsyncAdvAccount,
	fetchCennectAdvAccount,
	fetchUnCennectAdvAccount
} from "@/api/modules/AdAccount";
import { fetchBatchBindingStrategyWidthAdv } from "@/api/modules/strategy";
import { Button, Form, Input, message, Modal, Select, Switch, Tag, Tooltip, Table, Divider } from "antd";
import { useEffect, useRef, useState } from "react";
import { accountType } from "@/pages/AdAccount/interface.typing";
import { useDebounce } from "@/utils/util";
import { useTranslation } from "react-i18next";
import refreshIcon from "@/assets/icons/account/刷新.png";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { set } from "lodash";

const AdvModal: React.FC<{
	open: boolean;
	onCancel: () => void;
	reloadTable: () => void;
	ruleList: any[];
}> = ({ open, onCancel, reloadTable, ruleList }) => {
	const { t } = useTranslation();

	const [total, setTotal] = useState(0);
	const [selectedAdvList, setSelectedAdvList] = useState([]);
	const [filterParams, setFilterParams] = useState({
		queryData: "",
		tiktokUserId: "",
		isActive: ""
	});

	const actionRef = useRef();
	const columns: ProColumns<accountType>[] = [
		{
			title: t("account.table.column.advName"),
			dataIndex: "advName",
			key: "advName",
			width: "40%",
			render: (_, record) => <div className="AdAccount_table_advName">{record.advName}</div>
		},
		{
			title: (
				<div>
					{t("account.table.column.status")}
					<Tooltip title={t("account.table.column.status.tips")}>
						<QuestionCircleOutlined style={{ marginLeft: "0.5rem" }} />
					</Tooltip>
				</div>
			),
			dataIndex: "status",
			key: "status",
			width: "15%",
			render: (_, record) => {
				if ([1,8,9].indexOf(record.status)>=0) {
					return <Tag color="green">{t("account.table.column.status.enable")}</Tag>;
				} else {
					return <Tag color="red">{t("account.table.column.status.Restricted")}</Tag>;
				}
			}
		},
		{
			title: t("account.table.column.advId"),
			dataIndex: "advId",
			align: "right",
			key: "advId"
		}
	];

	useEffect(() => {
		setSelectedAdvList([]);
	}, [open]);
	const handleBinding = () => {
		if (!ruleList.length) {
			message.info("请选择规则");
			return;
		}
		if (!selectedAdvList.length) {
			message.info("请选择广告账号");

			return;
		}
		console.log("选中的策略", ruleList);
		console.log("选中的账户", selectedAdvList);
		fetchBatchBindingStrategyWidthAdv({
			advIds: selectedAdvList.map(item => item.advId),
			strategyIds: ruleList.map(item => item.strategyId)
		}).then(res => {
			if (res.code === 200) {
				message.success(t("message.success"));
				onCancel();
				reloadTable();
			} else {
				message.error(res.message);
			}
		});
	};
	const searchRules = useDebounce(value => {
		setFilterParams(...value);
		if (actionRef?.current) {
			actionRef?.current?.reload();
		}
	}, 800);
	const fetchData = async params => {
		let res = await fetchADAccountList({
			...params,
			...filterParams,
			isActive: 1
		});

		setTotal(res.data.map?.activeNum);
		return {
			success: true,
			data: res.data.list.map((item, index) => {
				return {
					...item,
					key: index
				};
			}),
			total: res.data.total
		};
	};

	console.log("selectedAdvList", selectedAdvList);
	return (
		<Modal
			width={1000}
			title={t("account.table.connectedAccount.title")}
			open={open}
			onCancel={() => {
				setSelectedAdvList([]);
				onCancel();
			}}
			onOk={() => handleBinding()}
		>
			<Divider style={{ margin: 0 }} />
			<ProTable
				columns={columns}
				request={fetchData}
				actionRef={actionRef}
				pagination={{ pageSize: 10 }}
				search={false}
				toolBarRender={() => [
					<div key="select" className="startegy_list_search">
						<ProFormText
							fieldProps={{
								onChange: ({ target: { value } }) => {
									searchRules({
										...filterParams,
										queryData: value
									});
								}
							}}
							placeholder={t("account.table.search.name.placeholder")}
							style={{ width: 200 }}
							allowClear
						/>
					</div>
				]}
				rowSelection={{
					// 自定义选择项参考: https://ant.design/components/table-cn/#components-table-demo-row-selection-custom
					// 注释该行则默认不显示下拉选项
					selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
					selectedRowKeys: selectedAdvList.map(item => item.advId),
					defaultSelectedRowKeys: selectedAdvList,
					onChange: (selectedRowKeys, selectedRows) => {
						setSelectedAdvList(selectedRows);
					}
				}}
				rowKey="advId"
			/>
		</Modal>
	);
};

export default AdvModal;
